module.exports = __webpack_public_path__ + "static/Icons_ReverseMortgage_Large-23365d519f7ef8cfe38d376327c1bf36.png";